import React, { useCallback, useEffect, useState } from "react";
import { PieChart, Pie, Sector, ResponsiveContainer } from 'recharts';

// pie-chart
const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  return (
    <g className="no-outline">
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill="#1F2937">
        {payload.name}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill="#1F2937"
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill="#1F293730"
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke="#1F2937" fill="none" />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#1F2937">{`${value} Users`}</text>
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
        {`(${(percent * 100).toFixed(2)}%)`}
      </text>
    </g>
  );
};


export default function PCusers() {

  const [activeIndex, setActiveIndex] = useState(0);
  const onPieEnter = useCallback(
    (_, index) => {
      setActiveIndex(index);
    },
    [setActiveIndex]
  );

  const [items, setItems] = useState([]);
  useEffect(() => {
    fetchData();
  }, [])

  const fetchData = async () => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/get_analytics_hits_per_os`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem("tokenn")
        }
      }
    )
      .then(res => res.json())
      .then(
        (result) => {
          setItems(result?.data?.result || []);
        },
        (error) => {
          console.log(error);
        }
      )
  }
  const data = items.map(item =>
  ({
    name: item.Os, value: item.count
  })
  )

  return (
    <ResponsiveContainer width="100%" height={250} className="piechart">

      {data && data.length > 0 ? (
        <PieChart width={200} height={200}>
          <Pie
            activeIndex={activeIndex}
            activeShape={renderActiveShape}
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={50}
            outerRadius={65}
            fill="#1F2937"
            dataKey="value"
            onMouseEnter={onPieEnter}
          />
        </PieChart>
      ) : (
        <div style={{ textAlign: 'center' }}>
          <div style={{ padding: '20px' }}>No Data Available</div>
        </div>
      )}

    </ResponsiveContainer>
  );
}
